import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('updateIsExpanding')(function updateIsExpanding(
    recipientToExpand: ReadWriteRecipientViewState,
    isExpanding: boolean
) {
    recipientToExpand.isExpanding = isExpanding;
});
